import { runExpert } from "./experts.js";
import { log, pii } from "./log.js";
import { Collection } from "./ports.js";
import { routeByKeywords } from "./router/keyword.js";
/** Keyword routing only. The model router (M1) implements the same interface. */
export class KeywordRouter {
    async route(text, contacts) {
        return routeByKeywords(text, contacts);
    }
}
/** One message in, one card out. Everything the agent does goes through here, on every platform. */
export class Agent {
    ports;
    router;
    constructor(ports, router = new KeywordRouter()) {
        this.ports = ports;
        this.router = router;
    }
    async handle(text) {
        const start = Date.now();
        log.debug("chat: input", { text: pii(text) });
        const contacts = await this.ports.storage.list(Collection.contacts);
        const route = await this.router.route(text, contacts.map((c) => c.name));
        log.debug("chat: routed", { expert: route.expert, contact: pii(route.contact), text: pii(route.text) });
        const card = await runExpert(route, this.ports, contacts);
        await this.ports.storage.put(Collection.chat, `ch_${Date.now()}`, {
            text,
            route,
            card,
            at: this.ports.clock.now().toISOString(),
        });
        log.debug("chat: reply", { kind: card.kind, body: pii(card.body) });
        // What happened, never what was said: the expert, the outcome, the size of the message and the time taken.
        log.info("chat handled", { expert: route.expert, card: card.kind, chars: text.length, ms: Date.now() - start });
        return { route, card };
    }
}
//# sourceMappingURL=agent.js.map